"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _gift = require("../../store/gift/gift.selector");

var _useEmailPreview = require("../../hooks/useEmailPreview");

var _message = require("../../store/gift/postcard/message");

var _useGiftContext2 = require("../../hooks/useGiftContext");

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var _invitationType = require("../../store/gift/invitationType");

var _GiftPreview = _interopRequireDefault(require("../../components/GiftPreview/GiftPreview"));

var _gift2 = require("../../store/gift/gift.actions");

var _templates = require("../../store/templates/templates.constants");

var _GiftMessageSender = _interopRequireDefault(require("./GiftMessageSender"));

var _GiftMessageForm = _interopRequireDefault(require("./GiftMessageForm"));

var _GiftMessageHeader = _interopRequireDefault(require("./GiftMessageHeader"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GiftMessage = function GiftMessage() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      sidebarMode = _useGiftContext.sidebarMode;

  var isLoading = (0, _reactRedux.useSelector)(_message.getIsMessageLoading);
  var landingPreviewUrl = (0, _reactRedux.useSelector)(_message.getPreviewUrl);
  var isAlyceGiftCard = (0, _reactRedux.useSelector)(_gift.isAlyceGiftCardSelector);
  var isLinkInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedLinkInvitationType);
  var isDirectMailInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var emailPreviewUrl = (0, _useEmailPreview.useEmailPreview)();

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var trackMessagePreview = (0, _useTrackGiftingFlow.useTrackGiftingFlowMessagePreviewClicked)();
  var trackLandingPreview = (0, _useTrackGiftingFlow.useTrackGiftingFlowLandingPreviewClicked)();

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      hasErrors = _useState2[0],
      setHasErrors = _useState2[1];

  var isDisabled = isLoading || hasErrors;
  var campaignId = (0, _reactRedux.useSelector)(_gift.getGiftCampaignId);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var teamId = campaign === null || campaign === void 0 ? void 0 : campaign.team.id;
  var isEmailPreviewVisible = !isAlyceGiftCard && !isLinkInvitationType;
  var isLandingPreviewVisible = !isAlyceGiftCard;
  var onSetMessageAndContinue = (0, _react.useCallback)(function () {
    trackEvent('Gifting flow — clicked set message and continue', {
      gift_id: giftId,
      team_id: teamId
    });
    dispatch((0, _message.updateMessage)({
      giftId,
      isDraft: false
    }));
  }, [dispatch, giftId, teamId, trackEvent]);
  var onEmailPreview = (0, _react.useCallback)(function () {
    trackMessagePreview(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.EDIT_MESSAGE);
    dispatch((0, _message.updateMessage)({
      giftId,
      isDraft: true,
      previewUrl: emailPreviewUrl,
      sidebarMode
    }));
  }, [trackMessagePreview, dispatch, giftId, emailPreviewUrl, sidebarMode]);
  var onLandingPreview = (0, _react.useCallback)(function () {
    trackLandingPreview(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.EDIT_MESSAGE);
    dispatch((0, _message.updateMessage)({
      giftId,
      isDraft: true,
      previewUrl: landingPreviewUrl
    }));
  }, [dispatch, giftId, landingPreviewUrl, trackLandingPreview]);
  (0, _react.useEffect)(function () {
    if (isDirectMailInvitationType) {
      dispatch((0, _gift2.selectTemplate)(_objectSpread({}, _templates.defaultBlankTemplate)));
    }
  }, [dispatch, isDirectMailInvitationType]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_GiftMessageHeader.default, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 2,
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_GiftMessageForm.default, {
    setHasErrors: setHasErrors
  }), !isDirectMailInvitationType && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 2,
    pb: 3,
    borderBottom: "1px solid #eceae7"
  }, /*#__PURE__*/_react.default.createElement(_GiftMessageSender.default, null)), /*#__PURE__*/_react.default.createElement(_GiftPreview.default, {
    mt: 3,
    emailAvailable: isEmailPreviewVisible,
    landingAvailable: isLandingPreviewVisible,
    onEmailPreview: onEmailPreview,
    onLandingPreview: onLandingPreview,
    emailDisabled: isDisabled,
    landingDisabled: isDisabled
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    pt: 6
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "secondary",
    disabled: isDisabled,
    onClick: onSetMessageAndContinue,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      icon: "envelope",
      color: "inherit"
    })
  }, "Set message and continue"))));
};

var _default = /*#__PURE__*/(0, _react.memo)(GiftMessage);

exports.default = _default;